import { createSelector } from "reselect";

import { getHiddenTerritoriesIds } from "@app/store/iam";
import { VISIBLE_TERRITORIES_LIMIT } from "@app/util/consts";

import { RootState } from "../rootReducer";

const territoriesState = (state: RootState) => state.territories;

const getTerritoriesRaw = createSelector(territoriesState, ({ territories }) => territories);

export const areTerritoriesLoading = createSelector(territoriesState, (state) => state.loading);

export const haveAnyTerritories = createSelector(
  getTerritoriesRaw,
  (territories) => territories.length > 0
);

export const getTerritories = createSelector(
  getTerritoriesRaw,
  // Lazy ref: iam/selectors loads this module (via LocalSettings) before getHiddenTerritoriesIds is defined.
  (state: RootState) => getHiddenTerritoriesIds(state),
  (territories, hiddenIds) => {
    let visibleCount = 0;
    return territories.map((territory) => {
      const hidden = hiddenIds.includes(territory.id);
      visibleCount += hidden ? 0 : 1;
      return {
        ...territory,
        territoryDetail: {
          ...territory.territoryDetail,
          hidden: hidden || visibleCount > VISIBLE_TERRITORIES_LIMIT,
        },
      };
    });
  }
);

export const getTerritoryCount = createSelector(territoriesState, ({ total }) => total);

export const isLoading = createSelector(territoriesState, ({ loading }) => loading);
export const isCreating = createSelector(territoriesState, ({ creating }) => creating);
export const isDeleting = createSelector(territoriesState, ({ deleting }) => deleting);
export const getTerritoriesHavingShapeFetched = createSelector(
  territoriesState,
  ({ shapeLoading }) => shapeLoading
);
